import { render, staticRenderFns } from "./AppForgetPassword.vue?vue&type=template&id=3db9e858&scoped=true&"
import script from "./AppForgetPassword.vue?vue&type=script&lang=js&"
export * from "./AppForgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./AppForgetPassword.vue?vue&type=style&index=0&id=3db9e858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db9e858",
  null
  
)

export default component.exports